/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import { observable, action } from 'mobx';

export default class SectionGroup {
    id;

    @observable localizedText;

    @observable appSections = [];

    constructor(localizedText, appSections, id) {
        this.localizedText = localizedText;
        this.appSections = appSections;
        this.id = id;
    }

    @action
    addAppSection(appSectionSkeleton) {
        this.appSections.push(appSectionSkeleton);
    }

    getId() {
        return this.id;
    }

    removeAppSection(appSectionId) {
        this.appSections = this.appSections.filter(
            appSection => appSection.getId() !== appSectionId
        );
    }

    getAppSection(appSectionId) {
        return this.appSections.filter(
            appSection => appSection.getId() === appSectionId
        );
    }
}
